import type { ILabel } from '@ardoq/yfiles';
import { classes } from '@ardoq/common-helpers';
import { IconName } from '@ardoq/icons';
import {
  CollapsibleGraphGroup,
  GraphItem,
  hasColorAttributes,
} from '@ardoq/graph';
import { NO_EXPORT_CLASS_NAME } from '@ardoq/global-consts';
import { referenceInterface } from '@ardoq/reference-interface';
import { ensureContrast } from '@ardoq/color-helpers';
import { colors } from '@ardoq/design-tokens';
import { createSvgElement } from '@ardoq/dom-utils';
import { URL_BOX_ICON_CLASS_NAME, URL_ICON_SIZE } from './consts';
import { dataModelId } from 'tabview/graphComponent/graphComponentUtil';
import { Node as OldGraphNode } from 'graph/types';
import { Edge as OldGraphEdge } from 'graph/edge';
import { getComponentCssColors } from 'utils/modelCssManager/getCssColors';
import { getElementOpacityIfTransparentized } from 'tabview/blockDiagram/view/utils';
import { spriteIconElement } from 'tabview/spriteIconElement';

const getColorAttributes = (
  modelId: string,
  maybeGraphItem: object,
  isReference: boolean
) => {
  if (hasColorAttributes(maybeGraphItem)) {
    return maybeGraphItem.getCssColorAttributes();
  }

  return isReference
    ? referenceInterface.getCssColors(modelId, {
        useAsBackgroundStyle: false,
      })
    : getComponentCssColors(modelId, { useAsBackgroundStyle: false });
};

const renderUrlLabel = (label: ILabel) => {
  const outerG = createSvgElement('g', {
    class: NO_EXPORT_CLASS_NAME,
  });
  const g = createSvgElement('g');

  // How do we know all that?
  const graphNode = label.tag as GraphItem | OldGraphNode | OldGraphEdge; // performance critical: prefer as to instanceof
  const group = label.owner?.tag as CollapsibleGraphGroup; // using as and not instanceof for performance critical code

  const modelId = dataModelId(graphNode);

  const isComponent = graphNode.isComponent();
  const isReference = !isComponent && graphNode.isReference();

  outerG.appendChild(g);

  const urlRect = createSvgElement('rect', {
    width: URL_ICON_SIZE.toString(),
    height: URL_ICON_SIZE.toString(),
    rx: '6',
    ry: '6',
    class: classes(
      'yfiles-url-box',
      isComponent && 'component',
      isReference && 'integration'
    ),
    fill: 'white',
  });
  g.appendChild(urlRect);

  const backgroundColor = 'white';

  const cssColorAttributes = getColorAttributes(
    modelId,
    graphNode,
    isReference
  );

  const nodeColor = isReference
    ? (cssColorAttributes?.stroke ?? colors.black950)
    : (cssColorAttributes?.fill ?? colors.black950);

  const iconColor = ensureContrast(backgroundColor, nodeColor);
  const publicIcon = createSvgElement('g', {
    class: URL_BOX_ICON_CLASS_NAME,
    opacity: String(
      getElementOpacityIfTransparentized(group.isTransparentized)
    ),
  });

  g.appendChild(publicIcon);
  const urlIcon = spriteIconElement(IconName.OPEN_IN_NEW, {
    cx: URL_ICON_SIZE / 2,
    cy: URL_ICON_SIZE / 2,
    size: URL_ICON_SIZE,
    color: iconColor,
  });
  publicIcon.appendChild(urlIcon);
  return outerG;
};
export { renderUrlLabel };
